<template>
  <div>
    <el-tabs type="card">
      <!-- USer Englist form tab -->

      <el-tab-pane label="English Form">
        <form class="needs-validation" @submit.prevent="checkForm()">
          <div class="row">
            <div class="col-md-4">
              <base-input label="Select Role">
                <el-select
                  v-model="selectedRole"
                  value-key="roleId"
                  @change="setCustomerType"
                >
                  <el-option
                    v-for="(item, index) in roles"
                    :key="index"
                    :label="item.label"
                    :value="item"
                  />
                </el-select>
              </base-input>
            </div>
            <div v-if="selectedRole.label === 'Customer'" class="col-md-4">
              <base-input label="Select Customer Type">
                <el-radio v-model="user.customerTypes" label="person" @change="onCustomerTypeChange">Person</el-radio>
                <el-radio v-model="user.customerTypes" label="society" @change="onCustomerTypeChange">Society</el-radio>
                <el-radio v-model="user.customerTypes" label="firm" @change="onCustomerTypeChange">Firm</el-radio>
                <el-radio v-model="user.customerTypes" label="branch" @change="onCustomerTypeChange">Branch</el-radio>
              </base-input>
            </div>
            <div v-if="selectedRole.label === 'Customer' && user.customerTypes === 'branch'" class="col-md-4">
              <base-input label="Linked Branch">
                <el-select v-model="user.branchId" placeholder="Select branch..." clearable>
                  <el-option
                    v-for="b in branches"
                    :key="b.id"
                    :value="b.id"
                    :label="b.name"
                  />
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <base-input
                v-uppercase
                v-model="user.firstName"
                :label="
                  selectedRole.label === 'Customer' &&
                  user.customerTypes != 'person'
                    ? 'Name'
                    : 'First Name'
                "
                :class="{
                  'is-invalid': formErrors.find(i => i.field === 'firstName')
                }"
              />
            </div>
            <div
              v-if="
                user.customerTypes != 'society' &&
                  user.customerTypes != 'firm' &&
                  user.customerTypes != 'branch'
              "
              class="col-md-4"
            >
              <base-input
                v-uppercase
                v-model="user.lastName"
                label="Last Name"
              />
            </div>
            <div class="col-md-4">
              <base-input label="Select Preferable Type">
                <el-select v-model="user.preferredProductPriceType">
                  <el-option
                    v-for="(item, index) in productPriceTypes"
                    :key="index"
                    :value="item.label"
                    :label="item.label"
                  />
                </el-select>
              </base-input>
            </div>

            <div
              v-if="
                user.customerTypes != 'firm' &&
                  user.customerTypes != 'society' &&
                  user.customerTypes != 'branch'
              "
              class="col-md-4"
            >
              <base-input label="Gender">
                <base-radio v-model="user.gender" name="male">Male</base-radio>
                <base-radio v-model="user.gender" name="female"
                  >Female</base-radio
                >
              </base-input>
            </div>
            <div class="col-md-4">
              <base-input
                v-model="user.phone"
                :class="{
                  'is-invalid': formErrors.find(i => i.field === 'phone')
                }"
                label="Phone"
              />
            </div>
            <div v-if="selectedRole.label === 'Customer'" class="col-md-4">
              <base-input
                v-model="user.metaData.alternativePhone"
                :class="{
                  'is-invalid': formErrors.find(
                    i => i.field === 'alternativePhone'
                  )
                }"
                label="Alternative Phone"
              />
            </div>
            <div class="col-md-4">
              <base-input v-model="user.email" label="Email" />
            </div>

            <div class="col-md-4">
              <base-input v-model="user.creditLimit" label="Credit Limit" />
            </div>
            <div v-if="selectedRole.label === 'Customer'" class="col-md-4">
              <base-input
                v-model="user.metaData.gstNumber"
                label="GST Number"
              />
            </div>
            <div v-if="user.customerTypes === 'person'" class="col-md-4">
              <base-input v-model="user.age" label="Age" />
            </div>
          </div>
          <hr />
          <div>
            <div class="card-header">
              <h3 class="mb-0">Addresses</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12" style="text-align: right">
                  <base-button class="mb-4" @click="addMoreAddress()"
                    >Add</base-button
                  >
                </div>
              </div>
              <div
                v-for="(item, index) in user.addresses"
                :key="index"
                class="row"
              >
                <div class="col-md-4">
                  <base-input
                    v-model="item.address"
                    :class="{
                      'is-invalid': formErrors.find(i => i.field === 'address')
                    }"
                    label="Address In English"
                  />
                </div>

                <div class="col-md-4 ">
                  <base-input
                    v-model="item.addressMarathi"
                    label="मराठीमध्ये पत्ता"
                  />
                </div>

                <div class="society-information-remove-item">
                  <base-button
                    v-if="item.customerAddressId"
                    class="btn-sm"
                    @click="updateUserAddress(item)"
                    >Update</base-button
                  >

                  <span @click="removeAddress(index)">
                    <i class="ni ni-fat-remove text-red" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              selectedRole.label === 'Customer' &&
                user.customerTypes === 'society'
            "
            class="society-information"
          >
            <hr />
            <div class="card-header">
              <h3 class="mb-0">Society Details</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12" style="text-align: right">
                  <base-button class="mb-4" @click="addMore()">Add</base-button>
                </div>
              </div>
              <div
                v-for="(item, index) in user.metaData.societyInformation"
                :key="index"
                class="row"
              >
                <div class="col-md-3">
                  <base-input :label="item.label" v-model="item.name" />
                </div>
                <div class="col-md-2">
                  <base-input v-model="item.phone" label="Phone" />
                </div>
                <div class="col-md-3">
                  <base-input label="From Date">
                    <el-date-picker
                      v-model="item.fromDate"
                      type="date"
                      placeholder="Pick a day"
                    />
                  </base-input>
                </div>
                <div class="col-md-3">
                  <base-input label="To Date">
                    <el-date-picker
                      v-model="item.toDate"
                      type="date"
                      placeholder="Pick a day"
                    />
                  </base-input>
                </div>
                <div
                  v-if="user.metaData.societyInformation.length > 3"
                  class="society-information-remove-item"
                >
                  <span @click="removeSocietyInformation(index)">
                    <i class="ni ni-fat-remove text-red" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              selectedRole.label === 'Customer' && user.customerTypes === 'firm'
            "
            class="society-information"
          >
            <hr />
            <div class="card-header">
              <h3 class="mb-0">Firm Details</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12" style="text-align: right">
                  <base-button class="mb-4" @click="addMoreFirmInformation()"
                    >Add</base-button
                  >
                </div>
              </div>
              <div
                v-for="(item, index) in user.metaData.firmInformation"
                :key="index"
                class="row"
              >
                <div class="col-md-3">
                  <base-input :label="item.label" v-model="item.name" />
                </div>
                <div class="col-md-3">
                  <base-input v-model="item.phone" label="Phone" />
                </div>
                <div
                  v-if="user.metaData.firmInformation.length > 2"
                  class="society-information-remove-item"
                >
                  <span @click="removeFirmInformation(index)">
                    <i class="ni ni-fat-remove text-red" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <base-button
            :disabled="showLoader ? true : false"
            md
            type="primary"
            native-type="submit"
          >
            <span v-if="showLoader" class="btn-inner--icon"
              ><i class="fas fa-spinner fa-spin" />
            </span>
            <span class="btn-inner--text">Save</span>
          </base-button>
        </form>
      </el-tab-pane>
      <!-- User Marathi form tab -->
      <el-tab-pane label="Marathi Form">
        <form class="needs-validation">
          <div class="row">
            <div class="col-md-4">
              <base-input
                v-uppercase
                v-model="user.firstNameMarathi"
                :label="
                  selectedRole.label === 'Customer' &&
                  user.customerTypes != 'person'
                    ? 'Name'
                    : 'First Name'
                "
                :class="{
                  'is-invalid': formErrors.find(i => i.field === 'firstName')
                }"
              />
            </div>
            <div
              v-if="
                user.customerTypes != 'society' &&
                  user.customerTypes != 'firm' &&
                  user.customerTypes != 'branch'
              "
              class="col-md-4"
            >
              <base-input
                v-uppercase
                v-model="user.lastNameMarathi"
                label="Last Name"
              />
            </div>
          </div>
        </form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import {
  Select,
  Option,
  Form,
  Radio,
  DatePicker,
  Tabs,
  TabPane
} from "element-ui";
import Validator from "@/plugins/customValidator";
import Api from "@/middleware/api";
import endpoints from "@/utils/constants";

export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form,
    [Radio.name]: Radio,
    [DatePicker.name]: DatePicker,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  props: {
    editedUser: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    },
    redirectToUsers: {
      type: Boolean,
      default: false
    },
    customerType: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      selectedRole: {},
      districts: [
        {
          label: "Pune",
          value: "pune"
        }
      ],
      formErrors: [],
      showLoader: false,
      branches: [],
    };
  },

  computed: {
    ...mapState("user", ["user"]),
    ...mapGetters({
      userList: "user/getUserList",
      roles: "role/getRoles",
      productPriceTypes: "product/getProductPriceTypes"
    })
  },
  watch: {
    editedUser(value) {
      this.selectedRole.roleId = value.roleId;
      this.selectedRole.label = value.role ? value.role.label : "";
    },
    customerType: {
      immediate: true,
      handler(value) {
        if (value) {
          this.getRoles().then(() => {
            const [customer] = this.roles.filter(i => i.label === "Customer");
            this.selectedRole = customer;
          });
        }
      }
    }
  },

  mounted() {
    this.getRoles().then(res => {
      const role = res.filter(i => {
        return i.label === "Customer";
      });
      this.user.roleId = role[0].roleId;
      this.selectedRole.roleId = role[0].roleId;
      this.selectedRole.label = role[0].label;
    });
    this.getPriceTypes();
    this.fetchBranches();
    // if (!this.$route.params.userId) {
    //   this.resetUser();
    // }
  },

  methods: {
    ...mapActions({
      saveUser: "user/saveUser",
      getRoles: "role/getRoles",
      getUsers: "user/getUsers",
      getPriceTypes: "product/getProductPriceTypes",
      updateUser: "user/updateUser",
      updateCustomerAddress: "user/updateCustomerAddress"
    }),
    ...mapMutations({
      setUserRole: "user/setUserRole",
      resetUser: "user/resetUser"
    }),

    async fetchBranches() {
      try {
        var res = await new Api().call("get", endpoints.LARAVEL_BASE_URL + "/api/v1/branches");
        this.branches = res.data.data || res.data;
      } catch (e) {
        console.error("Failed to fetch branches:", e);
      }
    },
    onCustomerTypeChange(val) {
      if (val === 'branch') {
        this.user.preferredProductPriceType = 'Wholesale';
      } else {
        this.user.branchId = null;
        if (this.user.preferredProductPriceType === 'Wholesale') {
          this.user.preferredProductPriceType = 'Retail';
        }
      }
    },
    setCustomerType(item) {
      if (item.label != "Customer") {
        this.user.customerTypes = null;
        this.user.branchId = null;
      } else if (item.label === "Customer") {
        this.user.customerTypes = "person";
      }
      this.setUserRole(this.selectedRole.roleId);
    },
    checkForm() {
      this.formErrors = [];
      const userErrors = Validator.validateUser(this.user);
      this.formErrors = [...userErrors];
      if (!this.formErrors.length) {
        this.showLoader = true;
        this.submitUser();
      } else {
        this.formErrors.forEach(i => {
          this.$notify({
            message: i.msg,
            type: "danger",
            title: "Validation Error"
          });
        });
      }
    },
    submitUser() {
      if (this.showLoader === true) {
        if (this.user.userId) {
          this.updateUser()
            .then(() => {
              const userId = this.user.userId;
              this.$notify({
                message: "User Updated Succesfully!",
                type: "success",
                title: "Success"
              });
              if (this.redirectToUsers) {
                this.resetUser();
                this.selectedRole = {};
                this.$router.push("/users/list");
              } else {
                this.$emit("customer-updated", { userId });
                this.resetUser();
                this.selectedRole = {};
                this.$emit("close");
              }
              this.showLoader = false;
            })
            .catch(e => {
              this.showLoader = false;
            });
        } else {
          this.saveUser()
            .then(() => {
              this.resetUser();
              this.selectedRole = {};
              this.$notify({
                message: "User Created Succesfully!",
                type: "success",
                title: "Success"
              });
              if (this.redirectToUsers === true) {
                this.$router.push("/users/list");
                this.showLoader = false;
              } else {
                this.$emit("close");
                this.showLoader = false;
              }
            })
            .catch(e => {
              this.showLoader = false;
            });
        }
      }
    },
    updateUserAddress(item) {
      this.updateCustomerAddress(item).then(() => {
        this.$notify({
          message: "Address Updated Succesfully!",
          type: "success",
          title: "Success"
        });
        if (!this.redirectToUsers) {
          this.$emit("customer-updated", {
            userId: this.user.userId,
            addressOnly: true
          });
        }
      });
    },
    addMoreAddress() {
      this.user.addresses.push({
        address: "",
        addressMarathi: ""
      });
    },
    removeAddress(index) {
      this.user.addresses.splice(index, 1);
    },
    addMore() {
      this.user.metaData.societyInformation.push({
        name: "",
        label: "Member/Chair Person",
        phone: ""
      });
    },
    addMoreFirmInformation() {
      this.user.metaData.firmInformation.push({
        name: "",
        label: "Member/Chair Person",
        phone: ""
      });
    },
    removeSocietyInformation(index) {
      this.user.metaData.societyInformation.splice(index, 1);
    },
    removeFirmInformation(index) {
      this.user.metaData.firmInformation.splice(index, 1);
    }
  }
};
</script>
<style>
.society-information-remove-item {
  height: 60px;
  line-height: 118px;
  text-align: center;
  padding-left: 10px;
  font-size: 25px;
}
.is-invalid input {
  border-color: #fb6340;
}
</style>
